export enum MessengerAccountFields {
    TYPE = 'type',
    API_CONFIGS = 'apiConfigs',
    LOGIN_USER = 'loginUser',
    BOX_CONFIGURATION = 'boxConfiguration',
}
